<script setup lang="ts">
import { DateFormat } from '@brighterly/lib-core-types/date/enums'

import { formatDate } from '@shared/lib/format'

import { useTutorLegalStore } from '../../model/legal/store'
import { TUTOR_LEGAL_PERSONAL_FIELDS, TUTOR_LEGAL_ADDRESS_FIELDS } from '../../config/tutor-legal'
import TutorLegalColumn from './TutorLegalColumn.vue'
import TutorLegalRows from './TutorLegalRows.vue'
import TutorLegalUpdatedAt from './TutorLegalUpdatedAt.vue'
import TutorLegalGroup from './TutorLegalGroup.vue'
import TutorLegalField from './TutorLegalField.vue'

defineOptions({
  name: 'TutorLegalPersonalInfo',
})

const tutorLegalStore = useTutorLegalStore()

const updatedAt = computed<string>(() => {
  const value = tutorLegalStore.getBilling?.updated_at
  return value ? formatDate(value, DateFormat.KanbanDate) : ''
})
</script>

<template>
  <TutorLegalColumn>
    <TutorLegalGroup
      title="Personal info"
      divided
    >
      <TutorLegalRows>
        <TutorLegalField
          v-for="field in TUTOR_LEGAL_PERSONAL_FIELDS"
          :key="field.key"
          :label="field.label"
          :tooltip="field.tooltip"
          :type="field.type"
          :model-value="tutorLegalStore.getForm[field.key]"
          :state="tutorLegalStore.getFieldState(field.key)"
          @update:model-value="value => tutorLegalStore.setFormField(field.key, value)"
        />
        <TutorLegalField
          label="Phone number"
          tooltip="Synced from the tutor's General info — edit it there"
          readonly
          :model-value="tutorLegalStore.getBilling?.phone ?? ''"
        />
      </TutorLegalRows>
    </TutorLegalGroup>

    <TutorLegalGroup divided>
      <TutorLegalRows>
        <TutorLegalField
          v-for="field in TUTOR_LEGAL_ADDRESS_FIELDS"
          :key="field.key"
          :label="field.label"
          :tooltip="field.tooltip"
          :model-value="tutorLegalStore.getForm[field.key]"
          :state="tutorLegalStore.getFieldState(field.key)"
          @update:model-value="value => tutorLegalStore.setFormField(field.key, value)"
        />
      </TutorLegalRows>
    </TutorLegalGroup>

    <TutorLegalUpdatedAt :value="updatedAt" />
  </TutorLegalColumn>
</template>
